import React, { useEffect } from "react";
import { Button } from "@/components/common/Button";
import { MicIcon } from "@/components/common/icons/MicIcon";
import { SendIcon } from "@/components/common/icons/SendIcon";
import { useSound } from "@/api/useSound";
import { useRecording } from "@/api/useRecording";
import { CardsIcon } from "@/components/common/icons/CardsIcon";
import { ChatIcon } from "@/components/common/icons/ChatIcon";
import { PauseIcon } from "@/components/common/icons/PauseIcon";

import styles from "./VoiceInputPanel.module.css";

type Props = {
  disabled?: boolean;
  onRecord: (data: string) => void;
  onMore?: () => void;
  onMic: () => void;
};

export const VoiceInputPanel: React.FC<Props> = ({
  onMore,
  onRecord,
  onMic,
  disabled,
}) => {
  const { play: playStart } = useSound("/sounds/recordStart.mp3", "audio/mpeg");
  const { play: playStop } = useSound("/sounds/recordPause.mp3", "audio/mpeg");
  const { play: playDelete } = useSound(
    "/sounds/recordDelete.mp3",
    "audio/mpeg"
  );
  const {
    data,
    havePermissions,
    initialized,
    startRecording,
    stopRecording,
    cancelRecording,
    isRecording,
  } = useRecording({
    onStart: () => {
      playStart();
    },
    onStop: () => {
      playStop();
    },
    onCancel: () => {
      playDelete();
    },
  });

  useEffect(() => {
    if (data) {
      onRecord(data);
    }
  }, [data]);

  return (
    <div className={styles.container}>
      <div className={styles.flex}>
        {isRecording ? (
          <Button
            variant="secondary"
            onClick={cancelRecording}
            disabled={!havePermissions}
            className={styles.secondaryButton}
          >
            <PauseIcon className={styles.PauseIcon} />
          </Button>
        ) : (
          <Button
            variant="secondary"
            onClick={onMic}
            className={styles.secondaryButton}
          >
            <ChatIcon className={styles.chatIcon} />
          </Button>
        )}
        {isRecording && (
          <Button
            disabled={disabled || !havePermissions}
            className={styles.recordButton}
            variant="primary"
            onClick={stopRecording}
          >
            <div className={styles.pulse} />
            <SendIcon className={styles.sendIcon} />
          </Button>
        )}
        {!isRecording && (
          <Button
            disabled={disabled || !havePermissions}
            className={styles.recordButton}
            variant="primary"
            onClick={startRecording}
          >
            <MicIcon className={styles.recordIcon} />
          </Button>
        )}
        <Button
          variant="secondary"
          onClick={onMore}
          disabled={isRecording || !havePermissions}
          className={styles.secondaryButton}
        >
          <CardsIcon className={styles.cardsIcon} />
        </Button>
      </div>
      {!havePermissions && initialized && (
        <div className={styles.permissionContainer}>
          <div className={styles.permissions}>
            Autorisations de microphone requises
          </div>
        </div>
      )}
    </div>
  );
};
